var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilesEmptyPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 123,
    viewBox: "0 0 126 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.5781 22.9337L119.561 29.9417C122.55 30.4792 124.538 33.3385 124.001 36.3281L115.464 83.8144C114.926 86.804 112.067 88.7919 109.077 88.2545L70.0949 81.2464C67.1053 80.7089 65.1174 77.8496 65.6549 74.86L74.1917 27.3737C74.7292 24.3841 77.5885 22.3962 80.5781 22.9337Z",
    fill: "#FAFAFA",
    stroke: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5549 54.2035C74.6575 53.6323 75.2038 53.2525 75.775 53.3552L113.468 60.1314C114.039 60.2341 114.419 60.7804 114.316 61.3516C114.213 61.9228 113.667 62.3026 113.096 62.1999L75.4032 55.4237C74.832 55.321 74.4522 54.7747 74.5549 54.2035Z",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.917 59.0713C74.0197 58.5001 74.566 58.1203 75.1372 58.223L112.83 64.9992C113.401 65.1019 113.781 65.6482 113.678 66.2194C113.575 66.7906 113.029 67.1704 112.458 67.0677L74.7653 60.2915C74.1941 60.1888 73.8143 59.6426 73.917 59.0713Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7575 64.2013C72.8602 63.6301 73.4065 63.2503 73.9777 63.353L111.67 70.1292C112.242 70.2318 112.621 70.7781 112.519 71.3493C112.416 71.9205 111.87 72.3003 111.298 72.1977L73.6058 65.4215C73.0346 65.3188 72.6548 64.7725 72.7575 64.2013Z",
    fill: "#F0F0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7763 48.7289C75.879 48.1577 76.4253 47.7779 76.9965 47.8805L114.689 54.6567C115.26 54.7594 115.64 55.3057 115.537 55.8769C115.435 56.4481 114.888 56.8279 114.317 56.7252L76.6246 49.949C76.0534 49.8464 75.6736 49.3001 75.7763 48.7289Z",
    fill: "#F0F0F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9337 70.1033C72.1505 68.8975 73.3038 68.0957 74.5097 68.3125L109.904 74.6755C111.11 74.8922 111.912 76.0455 111.695 77.2514C111.478 78.4573 110.325 79.2591 109.119 79.0423L73.7246 72.6793C72.5187 72.4625 71.7169 71.3092 71.9337 70.1033Z",
    fill: "#F0F0F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5004 47.2783C103.146 47.1269 105.979 44.0488 105.827 40.4032C105.676 36.7575 102.598 33.9249 98.952 34.0764C95.3064 34.2278 92.4738 37.3059 92.6252 40.9515C92.7767 44.5971 95.8548 47.4297 99.5004 47.2783Z",
    fill: "#F5F5F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1621 21.4396L6.32532 33.1495C3.42354 34.0476 1.7992 37.1279 2.69725 40.0297L16.9616 86.1205C17.8596 89.0222 20.94 90.6466 23.8418 89.7485L61.6786 78.0386C64.5804 77.1406 66.2047 74.0602 65.3067 71.1584L51.0423 25.0677C50.1443 22.1659 47.0639 20.5416 44.1621 21.4396Z",
    fill: "#FAFAFA",
    stroke: "#F0F0F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9543 51.7415C53.7827 51.1871 53.1942 50.8767 52.6398 51.0483L16.0549 62.3707C15.5005 62.5423 15.1901 63.1308 15.3617 63.6852C15.5333 64.2397 16.1218 64.55 16.6762 64.3784L53.2611 53.056C53.8155 52.8844 54.1259 52.2959 53.9543 51.7415Z",
    fill: "#F0F0F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1811 56.4952C55.0095 55.9407 54.4209 55.6304 53.8665 55.802L17.2816 67.1244C16.7272 67.296 16.4169 67.8845 16.5884 68.4389C16.76 68.9933 17.3486 69.3037 17.903 69.1321L54.4879 57.8097C55.0423 57.6381 55.3526 57.0496 55.1811 56.4952Z",
    fill: "#F0F0F0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9575 61.4454C56.7859 60.891 56.1974 60.5806 55.643 60.7522L19.0581 72.0746C18.5037 72.2462 18.1933 72.8347 18.3649 73.3892C18.5365 73.9436 19.125 74.2539 19.6794 74.0823L56.2643 62.7599C56.8187 62.5883 57.1291 61.9998 56.9575 61.4454Z",
    fill: "#F0F0F0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0743 46.4566C51.9027 45.9022 51.3142 45.5919 50.7598 45.7634L14.1749 57.0859C13.6204 57.2574 13.3101 57.846 13.4817 58.4004C13.6533 58.9548 14.2418 59.2652 14.7962 59.0936L51.3811 47.7712C51.9355 47.5996 52.2459 47.011 52.0743 46.4566Z",
    fill: "#F0F0F0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4949 67.2029C58.1327 66.0325 56.8902 65.3773 55.7198 65.7396L21.3657 76.3716C20.1953 76.7338 19.5401 77.9763 19.9023 79.1467C20.2646 80.3171 21.507 80.9723 22.6774 80.6101L57.0316 69.9781C58.202 69.6158 58.8572 68.3734 58.4949 67.2029Z",
    fill: "#F0F0F0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.535 47.2499C34.1768 47.4747 37.3114 44.7047 37.5362 41.0629C37.7611 37.4211 34.9911 34.2865 31.3492 34.0617C27.7074 33.8368 24.5729 36.6069 24.348 40.2487C24.1232 43.8905 26.8932 47.0251 30.535 47.2499Z",
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1092_91871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.4353 17H40.959C37.6453 17 34.959 19.6863 34.959 23V83.9362C34.959 87.2499 37.6453 89.9362 40.959 89.9362H72.5855C73.6649 89.9362 74.6985 89.4999 75.4515 88.7265L85.4207 78.4869L97.4353 66.9358V23C97.4353 19.6863 94.749 17 91.4353 17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0741 78.1265L85.0682 78.1322L85.0624 78.1381L75.0933 88.3777C74.4344 89.0545 73.53 89.4362 72.5855 89.4362H40.959C37.9214 89.4362 35.459 86.9738 35.459 83.9362V23C35.459 19.9624 37.9214 17.5 40.959 17.5H91.4353C94.4729 17.5 96.9353 19.9624 96.9353 23V66.723L85.0741 78.1265Z",
    stroke: "#F5F5F5"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0112 48.3908C70.9144 48.3908 74.0786 45.2266 74.0786 41.3234C74.0786 37.4201 70.9144 34.2559 67.0112 34.2559C63.1079 34.2559 59.9437 37.4201 59.9437 41.3234C59.9437 45.2266 63.1079 48.3908 67.0112 48.3908Z",
    fill: "#EA1F63"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7435 56.1537C41.7435 55.4511 42.3131 54.8816 43.0157 54.8816H89.3782C90.0808 54.8816 90.6504 55.4511 90.6504 56.1537C90.6504 56.8563 90.0808 57.4258 89.3782 57.4258H43.0157C42.3131 57.4258 41.7435 56.8563 41.7435 56.1537Z",
    fill: "#F0F0F0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0262 62.0904C42.0262 61.3878 42.5958 60.8182 43.2984 60.8182H89.6609C90.3635 60.8182 90.9331 61.3878 90.9331 62.0904C90.9331 62.793 90.3635 63.3625 89.6609 63.3625H43.2984C42.5958 63.3625 42.0262 62.793 42.0262 62.0904Z",
    fill: "#F0F0F0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7435 68.4511C41.7435 67.7485 42.3131 67.1789 43.0157 67.1789H89.3782C90.0808 67.1789 90.6504 67.7485 90.6504 68.4511C90.6504 69.1537 90.0808 69.7232 89.3782 69.7232H43.0157C42.3131 69.7232 41.7435 69.1537 41.7435 68.4511Z",
    fill: "#F0F0F0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2968 66.7979L97.4355 67.0015L74.2543 89.9362V70.7977C74.2543 68.5719 76.0712 66.7742 78.2968 66.7979Z",
    fill: "url(#paint0_linear_1092_91871)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M66.6569 51.6233C66.6476 51.6097 66.6373 51.5954 66.6271 51.5818C67.2321 51.1348 67.8134 50.7261 68.3487 50.3751C68.358 50.4014 68.3666 50.4269 68.375 50.4525C68.927 52.1476 67.3495 52.6118 66.6569 51.6233Z",
    fill: "#E6F7FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1092_91871",
    x: 9.95898,
    y: 0,
    width: 112.476,
    height: 122.936,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1092_91871"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1092_91871",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1092_91871",
    x1: 75.8641,
    y1: 67.7208,
    x2: 85.8449,
    y2: 76.9504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesEmptyPlaceholder);
export default __webpack_public_path__ + "static/media/filesEmptyPlaceholder.1f088b953ea35ce7669253faa7a70bf4.svg";
export { ForwardRef as ReactComponent };